import { PostTypes } from 'constants/postTypes'
import React, { useEffect, useState } from 'react'

import { Box } from 'widgets/Box'
import { InputAction } from 'widgets/InputAction'
import { Modal } from 'widgets/Modal'

import { generateDynamicLink } from 'utils/links'
import { copyLinkToClipboard, getPostLink } from 'utils/links/links'

interface SharePostModalProps {
  handleClose: () => void
  isOpen: boolean
  postId: string
  postType: PostTypes
  completionId?: string
  testID?: string
}

export const SharePostModal = ({
  handleClose,
  isOpen,
  postId,
  postType,
  completionId,
  testID,
}: SharePostModalProps): JSX.Element => {
  const [postLink, setPostLink] = useState<string>('')

  useEffect(() => {
    generateDynamicLink(getPostLink(postId, postType, completionId)).then((dynamicLink) =>
      setPostLink(dynamicLink),
    )
  }, [postId, postType, completionId])

  if (!isOpen) return <></>

  return (
    <Modal isVisible={isOpen} onClose={handleClose} title='Share post' testID={testID}>
      <Box>
        <InputAction
          type='light'
          value={postLink}
          action={() => copyLinkToClipboard(postLink)}
          actionContent='Copy link'
        />
      </Box>
    </Modal>
  )
}
